// 如果要更換Router Path的名稱請更改此項目
export const DOC = "document";
export const HOME_PAGE = "";



// WEBPACK FOOTER //
// ./src/constants.js